module.exports = __webpack_public_path__ + "media/tier-3-xxxmas-276e04ba4b231a6431b48372b9f3f8d4.mp3";